

const columnList: Array<any> = [
    {
        prop: "user_id",
        label: "用户id",
        width: 80,
    },
    {
        prop: "nick_name",
        label: "用户昵称",
        width: 80,
    },
    {
        prop: "project_name",
        label: "项目名称",
        width: 100,
    },
    {
        prop: "pay_text",
        label: "支付方式",
        width: 80,
    },
    {
        prop: "store_name",
        label: "门店",
        width: 80,
    },
    {
        prop: "create_time_text",
        label: "下单时间",
        width: 80,
    }
];

import { defineComponent, inject, ref, onMounted, reactive } from "vue";
import { getOrderTable } from "@/api/http";
import { validateInput } from "@/assets/js/formRules";
import { Request } from "@/api/request";

export default defineComponent({
    name: "projectStatistics",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["项目统计"]);
        const headClass = inject("headClass");
        let loading = ref(false),
            userinfo = ref(false),
            tableData = ref([] as Array<any>),
            currentPage = ref(1),
            pageSize = ref(10),
            total = ref(1);
        
        
        let getTableData = () => {
                loading.value = true;
                Request.axiosInstance({
                    url: 'adminapi/Order/vipCardStatistics',
                    data: {page:currentPage.value,pagesize:pageSize.value,type:1}
                }).then((res: any) => {
                    tableData.value = res.content.list;
                    total.value = res.content.total;
                    loading.value = false;
                })
            },
            handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            };
        onMounted(async() => {
            getTableData();
        });
        
        return {
            loading,
            tableData,
            headClass,
            getTableData,
            currentPage,
            pageSize,
            columnList,
            total,
            handleSizeChange,
            handleCurrentChange,
        };
    },
});
